import React, { useCallback, useMemo } from 'react'
import { Route, useHistory } from 'react-router'
import {
  setIsSidebarVisible
} from 'store/redux/layout'
import { useDispatch, useSelector } from 'react-redux'
import Activities from '../../Board/Activities'
import { navigationController } from 'components/Modal'
import { useColor } from 'utils/colors'
import LayoutGroupItem from './LayoutGroupItem'
import LayoutGroupItemIcon from './LayoutGroupItemIcon'

type Props = {
  boardId: number
}

const LayoutGroupBoard: React.FC<Props> = ({
  boardId,
}) => {
  const dispatch = useDispatch()

  const history = useHistory()

  const { push } = navigationController.useActions()

  const name = useSelector<any, number>(state => state.kanbo.boardsById[boardId].name)

  const unreadActivitiesCount = useSelector<any, number>(state => state['view-home'].unreadBoardActivitiesCount[boardId])

  const hasAccess = useSelector<any, boolean>(state => state.kanbo.boardsById[boardId].hasAccess)
  const isBusy = useSelector<any, boolean>(state => state.kanbo.boardsById[boardId].isBusy)
  const isClosed = useSelector<any, boolean>(state => state.kanbo.boardsById[boardId].isClosed)
  const isLocked = useSelector<any, boolean>(state => state.kanbo.boardsById[boardId].isLocked)

  const background = useSelector<any, any>(state => state.kanbo.boardsById[boardId].background)

  const imageSet = useSelector<any, any | undefined>(
    state =>
      background?.type === 'image'
        ? state.kanbo.branding.imageSets.byId[background?.image]
        : undefined
  )

  const backgroundColor = useColor(background?.type === 'color' ? background.color : undefined)

  const style = useMemo(() => {
    if (!background) return undefined

    switch (background.type) {
      case 'image':
        return {
          backgroundImage: `url(${imageSet?.images['favicon32'] || imageSet?.images['favicon64'] || imageSet?.images['favicon180'] || imageSet?.images[0]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }
      case 'color':
        return {
          backgroundColor,
        }
    }
  }, [background, imageSet, backgroundColor])

  const handleBoardActivityClick = useCallback(() => {
    push(() => <Activities boardId={boardId} />, { position: 'left' })
  }, [push, boardId])

  if (!hasAccess || isBusy || isClosed || isLocked) return null

  return (
    <Route
      path={`/board/${boardId}`}
    >
      {({ match }) =>
        <LayoutGroupItem
          icon={
            <LayoutGroupItemIcon
              style={{
                width: 32,
                height: 32,
                borderRadius: 5,
                ...style,
              }}
            />
          }
          title={
            unreadActivitiesCount > 0 ? (
              <b>{name}</b>
            ) : name
          }
          selected={Boolean(match)}
          badge={unreadActivitiesCount}
          onBadgeClick={handleBoardActivityClick }
          onClick={() => {
            history.push(`/board/${boardId}`)

            dispatch(setIsSidebarVisible(false))
          }}
        />
      }
    </Route>
  )
}

export default LayoutGroupBoard

